import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/switching/professional/pro-xg-24-poe.png";
import { type Product } from "../../types";
import { switchingProfessional } from "../product-list-groups/switchingProfessional";
import {
  downlinkSpeed,
  etherlighting,
  poeAvailability,
  poeOutput,
  portCount,
  proAvSupport,
  uplinkSpeed,
} from "../properties";

export const professionalXg24PoE: Product = {
  id: "professionalXg24PoE",
  productTitle: "Pro XG 24 PoE",
  description: "professionalXg24PoE.description",
  storePathParts: {
    category: UniFiChildCategorySlug.SwitchingProfessionalMaxXg,
    productSlug: "usw-pro-xg-24-poe",
  },
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.Switching}/usw-pro-xg-24-poe`,
  ],
  image: { src: image, width: 200, height: 140 },
  isNew: true,
  productListGroup: switchingProfessional,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442 x 480 x 44 mm\n(17.4 x 18.9 x 1.7")',
      },
    },
    {
      propertyId: portCount.id,
      value: {
        type: "string",
        value: "24 + 2 SFP28",
      },
    },
    {
      propertyId: downlinkSpeed.id,
      value: {
        type: "translation",
        value: "commons.speed.upTo10Gbps",
      },
    },
    {
      propertyId: uplinkSpeed.id,
      value: {
        type: "string",
        value: "25 Gbps",
      },
    },
    {
      propertyId: poeOutput.id,
      value: {
        type: "string",
        value: "PoE+++",
      },
    },
    {
      propertyId: poeAvailability.id,
      value: {
        type: "string",
        value: "720 W",
      },
    },
    {
      propertyId: etherlighting.id,
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: proAvSupport.id,
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: "generalRedundancy",
      value: {
        type: "translation",
        value: "commons.powerRedundancy.dcPowerBackup",
      },
    },
    {
      propertyId: "mounting",
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
  ],
};
